var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineChartUp01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "line-chart-up-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M18.2891 17.5786H4.6224C4.15569 17.5786 3.92233 17.5786 3.74407 17.4878C3.58727 17.4079 3.45978 17.2804 3.37989 17.1236C3.28906 16.9453 3.28906 16.712 3.28906 16.2453V2.57861M17.4557 6.74528L14.19 10.2308C14.0662 10.3629 14.0044 10.429 13.9297 10.4631C13.8638 10.4932 13.7912 10.5057 13.719 10.4992C13.6373 10.4918 13.5569 10.4501 13.3963 10.3667L10.6818 8.95722C10.5212 8.8738 10.4409 8.83209 10.3591 8.82473C10.2869 8.81822 10.2143 8.83065 10.1484 8.86078C10.0738 8.89492 10.0119 8.96097 9.88812 9.09307L6.6224 12.5786",
    stroke: "#F7F9F9",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChartUp01);
export default __webpack_public_path__ + "static/media/line-chart-up-01.24e90a40eaf2bf9a5a93c164f2d98bc6.svg";
export { ForwardRef as ReactComponent };